import { Component, OnInit, OnDestroy } from '@angular/core';
import { PasswordPolicyService } from './password-policy.service';
import { Subscription } from 'rxjs';
import { PasswordPolicyState } from './password-policy-state.modal';
import { PasswordPolicy } from '../error-messages';

@Component({
    selector: 'app-password-policy',
    templateUrl: './password-policy.component.html',
    styleUrls: ['./password-policy.component.scss'],
    standalone: false
})
export class PasswordPolicyComponent implements OnInit, OnDestroy {
  password: string;
  show = false;
  length: any;
  valid: any;
  capital: any;
  small: any;
  number: any;
  symbol: any;
  symbols = '! @ # $ % ^ & * - _ + = [ ] { } | \ : ‘ , . ? / ` ~ “ ( );';
  private subscription: Subscription;
  public PasswordPolicies = {
    lengthRequirement: PasswordPolicy.LENGTH_REQUIREMENT,
    upperCaseRequirement: PasswordPolicy.UPPERCASE_REQUIREMENT,
    lowerCaseRequirement: PasswordPolicy.LOWERCASE_REQUIREMENT,
    numericRequirement: PasswordPolicy.NUMERIC_REQUIREMENT,
    specialCharRequirement: PasswordPolicy.SPECIAL_CHARACTER_REQUIREMENT,
    characterList: PasswordPolicy.CHARACTER_LIST_1 + PasswordPolicy.CHARACTER_LIST_2,
  };

  constructor(
    private policyService: PasswordPolicyService
  ) { }

  ngOnInit() {
    this.subscription = this.policyService.policyState
      .subscribe((state: PasswordPolicyState) => {
        this.show = state.show;
        this.password = state.password;
        this.checkValidity();
        this.checkAllValidity();
      });
  }

  checkValidity() {
    this.length = this.policyService.length(this.password);
    this.capital = this.policyService.capital(this.password);
    this.small = this.policyService.small(this.password);
    this.number = this.policyService.number(this.password);
    this.symbol = this.policyService.symbol(this.password);
  }

  getColor(val: boolean) {
    if (val) {
      return '#28A745';
    } else {
      return '#bf1616';
    }
  }

  getBackgroundColor(val: boolean) {
    if (val) {
      return '#DFF1D6';
    } else {
      return '#f2dede';
    }
  }

  checkAllValidity() {
    this.valid = this.policyService.valid(this.password);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
